import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip, Textarea } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {
	
	render() {
		const { item } = this.props;

		return (
			<div id="modal-view-job-application">
				{
					item != null && (
						<div className="container-job-application">
							<h3><strong>Nombre:</strong> { item?.name } { item?.lastname }</h3>
							<h3><strong>Cédula:</strong> { item?.document_type?.name }{ item?.document }</h3>
							<h3><strong>Teléfono:</strong> { item?.phone }</h3>
							<h3><strong>Correo:</strong> { item?.email }</h3>
							<h3><strong>Dirección:</strong> { item?.address }</h3>
							<h3><strong>Experiencia Laboral:</strong> { item?.work_experience }</h3>
							<div className="row">
								<div className="col-md-6 text-center">
									{
										item?.photo != null && (
											<a href={ Constants.BASE_STORAGE + item?.photo } target="_blank">
												<Button className="btn-view">
													Ver Foto
												</Button>
											</a>
										)
									}
								</div>
								<div className="col-md-6 text-center">
									{
										item?.curriculum != null && (
											<a href={ Constants.BASE_STORAGE + item?.curriculum } target="_blank">
												<Button className="btn-view">
													Ver Curriculum
												</Button>
											</a>
										)
									}
								</div>
							</div>
						</div>
					)
				}
			</div>
		)
	}
}

export default ModalView;